import { render, staticRenderFns } from "./NotificacionFilters.vue?vue&type=template&id=4b8c094c"
import script from "./NotificacionFilters.vue?vue&type=script&lang=js"
export * from "./NotificacionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports